import { Fragment } from "react";

// Blots vary in width so they don't read as a uniform bar (and never hint at the real name's length).
const WIDTHS = ["4.6ch", "6.2ch", "5.1ch", "7ch", "5.6ch", "4.2ch"];

/** Renders text, turning each "[redacted]" marker into an ink blot that screen readers announce as such. */
export function RedactedText({ text }: { text: string }) {
  const parts = text.split("[redacted]");
  return (
    <>
      {parts.map((part, i) => (
        <Fragment key={i}>
          {part}
          {i < parts.length - 1 && <span className="redaction" role="img" aria-label="redacted name" style={{ ["--w" as string]: WIDTHS[i % WIDTHS.length] }} />}
        </Fragment>
      ))}
    </>
  );
}
